import { Button, Col, Form, Modal, Row, Select, Upload } from 'antd';
import styled from 'styled-components';
import TextArea from 'antd/lib/input/TextArea';
import { UploadOutlined } from '@ant-design/icons';
import { normFile } from '../../util/utils';
import { Task, TaskStatus, taskStatusKorean } from '../../modules/tasks';
import { useEffect, useState } from 'react';
import { User } from '../../modules/auth';

const { Option } = Select;

const StyledDiv = styled.div``;

interface TaskChangeStatusModalProps {
  isOpen: boolean;
  uploadProps: any;
  user: User;
  task: Task;
  onCreate: (value: any) => void;
  onClose: () => void;
}

function TaskChangeStatusModal({
  isOpen,
  uploadProps,
  user,
  task,
  onCreate,
  onClose,
}: TaskChangeStatusModalProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  const [statusList, setStatusList] = useState<any[]>([]);

  useEffect(() => {
    if (!mount) return;
    if (!isOpen) return;

    let _statusList: string[] = [];

    if (user.id === task.requester.id) {
      if (user.id === task.assignee.id) {
        if (
          task.status === TaskStatus.WORK_REQUEST ||
          task.status === TaskStatus.IN_PROGRESS ||
          task.status === TaskStatus.READY_FOR_REVIEW ||
          task.status === TaskStatus.HOLD ||
          task.status === TaskStatus.CLOSED
        ) {
          _statusList = [
            TaskStatus.IN_PROGRESS,
            TaskStatus.CLOSED,
            TaskStatus.HOLD,
          ];
        }
      } else {
        if (
          task.status === TaskStatus.WORK_REQUEST ||
          task.status === TaskStatus.IN_PROGRESS ||
          task.status === TaskStatus.READY_FOR_REVIEW
        ) {
          _statusList = [TaskStatus.CLOSED, TaskStatus.HOLD];
        }
        if (task.status === TaskStatus.HOLD) {
          _statusList = [
            TaskStatus.WORK_REQUEST,
            TaskStatus.IN_PROGRESS,
            TaskStatus.CLOSED,
            TaskStatus.HOLD,
          ];
        }
        if (task.status === TaskStatus.CLOSED) {
          _statusList = [
            TaskStatus.IN_PROGRESS,
            TaskStatus.CLOSED,
            TaskStatus.HOLD,
          ];
        }
      }
    } else {
      if (task.status === TaskStatus.WORK_REQUEST) {
        _statusList = [TaskStatus.IN_PROGRESS, TaskStatus.READY_FOR_REVIEW];
      } else if (task.status === TaskStatus.IN_PROGRESS) {
        _statusList = [TaskStatus.READY_FOR_REVIEW];
      } else {
        _statusList = [];
      }
    }

    const children: any = [];
    for (const status of _statusList) {
      children.push(
        <Option key={status} value={status}>
          {taskStatusKorean[status as keyof typeof taskStatusKorean]}
        </Option>,
      );
      setStatusList(children);
    }

    return () => setMount(false);
  }, [mount, user, task, isOpen]);

  return (
    <StyledDiv>
      <Modal
        open={isOpen}
        title="상태변경하기"
        okText="확인"
        cancelText="취소"
        onCancel={onClose}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              // form.resetFields();
              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <>
          <Row justify="center">
            <Col span={20}>
              <Form form={form} layout="vertical" initialValues={{}}>
                <Form.Item
                  name="status"
                  label="상태"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select allowClear placeholder="상태를 선택 하세요.">
                    {/* <Option value="0">{taskStatusKorean['0']}</Option>
                    <Option value="1">{taskStatusKorean['1']}</Option>
                    <Option value="2">{taskStatusKorean['2']}</Option>
                    <Option value="3">{taskStatusKorean['3']}</Option> */}
                    {statusList}
                  </Select>
                </Form.Item>
                <Form.Item name={['taskComment', 'description']} label="코멘트">
                  <TextArea rows={4} />
                </Form.Item>
                <Form.Item
                  name={['taskComment', 'file']}
                  label="첨부 이미지"
                  valuePropName="fileList"
                  getValueFromEvent={normFile}
                >
                  <Upload {...uploadProps}>
                    <Button icon={<UploadOutlined rev={undefined} />}>
                      이미지 올리기
                    </Button>
                  </Upload>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default TaskChangeStatusModal;
